export default "__VITE_ASSET__Cmtmj$ny__"